module.exports = __webpack_public_path__ + "static/media/slide1.7256f309.webp";